var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReceiptPercentage = function SvgReceiptPercentage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.75L14.25 14.25M14 10H14.01M10 14H10.01M5.75 4.75V19.25L7.3486 18.0066C7.72679 17.7125 8.26048 17.7279 8.62105 18.0434L10 19.25L11.3415 18.0762C11.7185 17.7463 12.2815 17.7463 12.6585 18.0762L14 19.25L15.379 18.0434C15.7395 17.7279 16.2732 17.7125 16.6514 18.0066L18.25 19.25V4.75H5.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgReceiptPercentage;